import { computed, Injectable, signal } from '@angular/core';
import { SlbMessage } from 'app/utils/interfaces/slb-messages.interface';

@Injectable({
  providedIn: 'root'
})
export class SlbInlineMessageService {
  private messageCollection = signal<SlbMessage[]>([]);

  readonly messages = computed(() => this.messageCollection());

  constructor() {}

  getMessages() {
    return this.messages;
  }


  addMessage(message: SlbMessage): void {
    if (!this.isOnCollection(message)) {
      this.messageCollection.update(messages => [...messages, message]);
    }
  }

  updateMessage(message: SlbMessage): void {
    const messages = this.messageCollection();
    const index = messages.findIndex(
      m => m.message === message.message && m.type === message.type
    );

    if (index === -1) {
      this.messageCollection.update(msgs => [...msgs, message]);
    } else {
      const updatedMessages = [...messages];
      updatedMessages[index] = message;
      this.messageCollection.set(updatedMessages);
    }
  }

  removeMessage(message: SlbMessage): void {
    this.messageCollection.update(messages =>
      messages.filter(m => m.message !== message.message)
    );
  }

  hasMessages(): boolean {
    return this.messageCollection().length > 0;
  }

  reset(): void {
    this.messageCollection.set([]);
  }

  private isOnCollection(message: SlbMessage): boolean {
    return this.messageCollection().some(
      m => m.message === message.message && m.type === message.type
    );
  }
}
